module.exports = __webpack_public_path__ + "media/packs/images/flags/QA-8c1f52e0dc55ad7560c069ab31a59d72.svg";